module.exports = __webpack_public_path__ + "static/media/plan-icon_starter.ea66b90e.svg";